import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getSyncData({ commit }) {
      try {
        const response = await api.get('/company/sync-data')
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async syncData({ commit }, data) {
      try {
        return await api.post('/company/sync-data', data)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
